export default __webpack_public_path__ + "static/media/casino-cctv.c62ee69b.svg";